import React from 'react';
import withFormContainer from './withFormContainer.jsx';

import './UserModerationForm.css';

class UserModerationForm extends React.Component {

    state = {
        days: null,
        originalDays: null,
        isBlocked: false,
        isShadowBan: false
    };

    componentDidMount() {

        this.props.changeLoading(true)
            .then(() => this.props.getBlockedUser(this.props.commentId))
            .then(({ days, isShadowBan }) => {

                return new Promise(resolve => {

                    this.setState({ days, originalDays: days, isBlocked: true, isShadowBan }, resolve);
                });
            })
            .catch(err => {
                return new Promise(resolve => {
                    this.setState({ isBlocked: false }, resolve);
                });
            })
            .then(() => {

                this.props.changeLoading(false);
            });
    }

    onChangeDays = ({ currentTarget: { value: days } }) => {

        this.setState({ days: days === '' ? null : parseInt(days.slice(0, 3)) });
    };

    onChangeShadowBan = ({ currentTarget: { value } }) => {

        this.setState({ isShadowBan: !!value });
    };

    onBlock = e => {

        e.preventDefault();

        this.props.changeLoading(true)
            .then(() => {

                return this.props.blockUser(this.props.commentId, this.state.days, this.state.isShadowBan);
            })
            .then(({ days }) => {

                return new Promise(resolve => {

                    this.setState({ isBlocked: true, originalDays: days }, resolve);
                });
            })
            .then(() => this.props.changeLoading(false));
    };

    onUnblock = () => {

        this.props.changeLoading(true)
            .then(() => {

                return this.props.unblockUser(this.props.commentId);
            })
            .then(() => {

                return new Promise(resolve => {

                    this.setState({ isBlocked: false, originalDays: null, isShadowBan: false }, resolve);
                });
            })
            .then(() => this.props.changeLoading(false));
    };

    get message() {

        let message = 'This user is not blocked';

        if (this.state.isBlocked) {

            message = 'This user is blocked';

            if (this.state.originalDays !== null) {
                message+= ` for ${this.state.originalDays} day`;
                if (this.state.originalDays !== 0) {
                    message+= 's';
                }
            } else {
                message+= ' forever';
            }
        }
        message+= '.';

        return message;
    }

    get shadowBan() {

        if (!this.props.isModerationPlus) {
            return null;
        }
        return (
            <div className="form-group">

                <label className="header">
                    Should they be aware that they are blocked?
                </label>

                <div className="block-option">

                    <label className="clearfix option">
                        <input
                            type="radio"
                            name="shadow_ban"
                            value="1"
                            checked={this.state.isShadowBan}
                            onChange={this.onChangeShadowBan}
                        />
                        <span>No</span>
                    </label>
                </div>

                <div className="block-option">

                    <label className="clearfix option">
                        <input
                            type="radio"
                            name="shadow_ban"
                            value=""
                            checked={!this.state.isShadowBan}
                            onChange={this.onChangeShadowBan}
                        />
                        <span>Yes</span>
                    </label>
                </div>

            </div>
        );
    }

    render() {
        return (
            <div className="settings user-moderation-form">

                <h3 className="form-container-header">
                    Moderation
                </h3>

                <form onSubmit={this.onBlock}>

                    <div className="message">{this.message}</div>

                    <div className="form-group">

                        <label className="header">Block this user</label>

                        <div className="block-option">

                            <label className="clearfix option">
                                <input
                                    type="radio"
                                    name="block_option"
                                    value=""
                                    checked={!this.state.days}
                                    onChange={this.onChangeDays}
                                />
                                <span>Forever</span>
                            </label>
                        </div>
                        <div className="block-option">

                            <label className="clearfix option">

                                <input
                                    type="radio"
                                    name="block_option"
                                    value="5"
                                    checked={!!this.state.days}
                                    onChange={this.onChangeDays}
                                />
                                For <input
                                type="number"
                                step="1"
                                placeholder="0"
                                min="0"
                                max="100"
                                value={this.state.days === null ? 0 : (this.state.days + '')}
                                onChange={this.onChangeDays}
                            /> days

                            </label>

                        </div>
                    </div>

                    {this.shadowBan}

                    <div className="form-group">
                        <button
                            disabled={this.props.loading}
                            className="btn primary-button"
                            type="submit"
                        >
                            {this.state.isBlocked ? 'Update' : 'Block'}
                        </button>

                        {this.state.isBlocked ? (
                            <button
                                className="btn secondary-button"
                                type="button"
                                onClick={this.onUnblock}
                                disabled={this.props.loading}
                            >
                                Unblock
                            </button>
                        ) : null}

                    </div>

                </form>

            </div>
        );
    }
}

export default withFormContainer(UserModerationForm);


// WEBPACK FOOTER //
// ./src/components/UserModerationForm.jsx